import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("orion_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-logout on 401: whenever an admin-scoped request comes back
// unauthorized (session expired, password changed on another device, etc)
// clear local credentials and bounce to the login screen.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    // Only trigger for admin-context requests — public endpoints (like the
    // OTP verify itself) rely on 401 to signal "wrong code" without
    // wiping state.
    const isAdminScope = /\/(admin|posts\/all|auth\/me|newsletter\/(subscribers|broadcast|preview)|seo\/format|media\/upload|pexels)/.test(url);
    const isLoginFlow = /\/auth\/(login|verify-otp)$/.test(url);
    if (status === 401 && isAdminScope && !isLoginFlow) {
      try {
        localStorage.removeItem("orion_token");
        localStorage.removeItem("orion_email");
      } catch {}
      if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin") {
        window.location.href = "/admin";
      }
    }
    return Promise.reject(error);
  }
);

export const mediaUrl = (mediaId, variant = "desktop") =>
  mediaId ? `${API}/media/${mediaId}/${variant}` : null;
